export default "__VITE_ASSET__CxtaYGux__"